import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

const AddUserModal = ({ show, handleClose, onAddUser }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Email is required');
            return;
        }
        if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            setError('Please enter a valid email address');
            return;
        }
        if (!password) {
            setError('Password is required');
            return;
        }
        if (password.length < 8) {
            setError('Password must be at least 8 characters long');
            return;
        }

        setIsSubmitting(true);
        try {
            const response = await onAddUser(email, password);
            setEmail('');
            setPassword('');
            setError('');
            handleClose();
            
        } catch (error) {
            console.log(error);
            // setError(err.message || 'Failed to create user');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleModalClose = () => {
        setEmail('');
        setPassword('');
        setError('');
        handleClose();
    };

    return (
        <Modal 
            show={show}
            className="custom-modal"
            centered
            onHide={handleModalClose}
        >
            <Modal.Body>
                <div className="login-container resetpwd-wrapper">
                    <div className="login-box resetpwd-box">
                        <h2 className='text-center'>Create User</h2>
                        <form className="login-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <div className="input-icon-container">
                                    <input 
                                        type="email" 
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Email Address" 
                                    />
                                    <span className="input-icon">
                                        <img src="/assets/icons/email-icon.svg" alt="Email Icon" />
                                    </span>
                                </div>
                            </div>
                            
                            <div className="form-group">
                                <div className="input-icon-container">
                                    <input 
                                        type="password" 
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Password" 
                                    />
                                    <span className="input-icon">
                                        <img src="/assets/icons/password-icon.svg" alt="Password Icon" />
                                    </span>
                                </div>
                            </div>
                            
                            {error && <span className="error-message text-danger">{error}</span>}
                            
                            <button 
                                type="submit" 
                                className="btn btn-primary btn-lg btn-xl generalBtn"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Creating...' : 'Create User'}
                            </button>
                            <div className="text-center mt-4">
                                <Button
                                    className="text-primary cancel"
                                    onClick={handleModalClose}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};


export default AddUserModal